/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import PlansCardGrid from 'modules/me/plans-card-grid';
import { getIndustryGroup } from 'state/current-user/selectors';
import { getCurrentRental } from 'state/current-rental/selectors';

/**
 * Style dependencies
 */
import './styles.scss';

const Plans = ({ industryGroup, currentRental }) => {
    let plans = [
        {
            id: 'kiosk',
            name: 'Customer Self Checkout',
            description: 'Let customers check themselves out using a dedicated kiosk device in your store.',
            url: '/dashboard/kiosk/subscribe',
        },
        {
            id: 'shopify-development',
            name: 'Shopify Website',
            description: 'Get a professionally built Shopify website with a convenient 14-month repayment plan.',
            url: '/dashboard/shopify-development/new',
        },
        {
            id: 'barcode-lookup',
            name: 'Barcode Lookup',
            description: 'Instantly look up product information and pricing by scanning barcodes.',
            url: '/dashboard/barcode-lookup/subscribe',
        },
        {
            id: 'roam',
            name: 'Roam',
            description: 'Accept payments and manage sales on the go using a mobile device.',
            url: '/dashboard/roam/subscribe',
        },
        {
            id: 'cloud-backup',
            name: 'Cloud Backup',
            description: 'Automatically back up your store data securely to the cloud every day.',
            url: '/dashboard/cloud-backup/subscribe',
        },
    ];

    const activeRentals = currentRental
        .filter(r => r.subscription.status === 'active')
        .filter(r => r.subscription.plan_id.toLowerCase().includes('retailer-rental'));

    const allowed = activeRentals.some(r =>
        r.subscription.plan_id.toLowerCase().includes('retailer-rental-advanced') ||
        r.subscription.plan_id.toLowerCase().includes('retailer-rental-ultimate')
    );

    if (industryGroup.toLowerCase() === 'newsxpress' || allowed) {
        plans.push({
            id: 'visual-deck',
            name: 'Visual Deck',
            description: 'Display promotions and product information on customer-facing screens.',
            url: '/dashboard/visual-deck/subscribe',
        });
    }

    plans.push({
        id: 'universal-importer',
        name: 'Universal Importer',
        description: 'Import products and data from a wide range of sources directly into your POS.',
        url: '/dashboard/universal-importer/subscribe',
    });

    return (
        <Box>
            <Topbar title='Available Plans' subTitle='Select a plan to get started' selected='plans' />
            <DocumentHead title='Plans' />
            <Main padding='xxlarge'>
                <Stack space='medium'>
                    <PlansCardGrid plans={plans} columns='3' />
                </Stack>
            </Main>
        </Box>
    );
};

export default connect((state) => ({
    industryGroup: getIndustryGroup(state),
    currentRental: getCurrentRental(state),
}), {})(Plans);
